import React from "react";
import "./Brands.css";
import Image01 from "../../assets/images/Lp/brand-image-01.png";
import Image02 from "../../assets/images/Lp/brand-image-02.png";
import Image03 from "../../assets/images/Lp/brand-image-03.png";

const Brands_data = [
  {
    id: 1,
    img: Image01,
  },
  {
    id: 1,
    img: Image02,
  },
  {
    id: 1,
    img: Image03,
  },
];
export default function Brands({ id }) {
  return (
    <div id={id} className="section py-constant">
      <div className="container">
        <h2 className="h2 title center">
          These Shopify brands{" "}
          <span className="accent">
            currently love<br></br> CustomerGenius!
          </span>
        </h2>
        <div className="flex flex-row images">
          {Brands_data.map((item) => {
            return (
              <div className="img-wrap">
                <img src={item.img} width={150  } alt="" />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
